/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';

@Injectable()
export class AdminOpsService {

  constructor(private http: HttpClient) { }


  addToGoldenset(edId: string, type: string, notes:string) {
    return this.http
      .post(
        `/api/v1/admin/ops/goldenset/add/${edId}`, { type: type, notes:notes }
      );
  }

  getObfuscatedEmail(edId: string) {
    return this.http
      .get(
        `/api/v1/admin/ops/goldenset/obfuscate/${edId}`
      );
  }

}



// WEBPACK FOOTER //
// ./client/app/services/admin/admin-ops.service.ts